var map = {
	"./banner-darkgray.png": 9555,
	"./banner-gray.png": 4937,
	"./banner-tutor.png": 4941,
	"./banner-white.png": 685,
	"./check_white.png": 84,
	"./close.png": 7504,
	"./down-gray.png": 9432,
	"./english-top-banner.png": 6320,
	"./global-top-banner.png": 9971,
	"./minus.png": 5672,
	"./more.png": 3116,
	"./plus.png": 9275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1959;